/**
 * Route for `aws-s3-export-scheduled-click-conversion-logs`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AwsS3ExportScheduledClickConversionLogsPage } from "../features/aws-s3-export-scheduled-click-conversion-logs/AwsS3ExportScheduledClickConversionLogsPage";

export const awsS3ExportScheduledClickConversionLogsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/aws-s3-export-scheduled-click-conversion-logs",
	component: AwsS3ExportScheduledClickConversionLogsPage,
});

export default awsS3ExportScheduledClickConversionLogsRoute;
